var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveAssignee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-cancel"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    clipPath: "url(#clip-cancel)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24632",
    "data-name": "Rectangle 24632",
    width: 7,
    height: 7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18662",
    "data-name": "Path 18662",
    d: "M3.447,3,5.908.54A.316.316,0,0,0,5.461.093L3,2.554.539.093A.316.316,0,0,0,.092.54L2.553,3,.092,5.462a.316.316,0,0,0,.447.447L3,3.448,5.461,5.908a.316.316,0,1,0,.447-.447Z",
    transform: "translate(0.5 0.498)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAssignee);
export default __webpack_public_path__ + "static/media/remove_assignee.e2e0741692d6cc05519cb8e51731bf2d.svg";
export { ForwardRef as ReactComponent };